import script from "./UpgradeRow.vue?vue&type=script&setup=true&lang=js"
export * from "./UpgradeRow.vue?vue&type=script&setup=true&lang=js"

import "./UpgradeRow.vue?vue&type=style&index=0&id=772d7924&lang=scss"

const __exports__ = script;

export default __exports__